import React from 'react';

import './Review.css';

import ObjectSelector from './ObjectSelector';

import Spinner from '../compUtils/Spinner';
import ThumbProfile from '../compUtils/ThumbProfile';

import seenWithIcon from '../icons/seenWith.svg';

import { getDateString } from '../util/util';

import { Link } from "react-router-dom";
import MultiObjectSelector from './MultiObjectSelector';
import ObjectModifiers from './ObjectModifiers';

import MovieThumb from './MovieThumb';



function Review(props) {


    return (
        <div class="box tile">
            {props.updateConclusion === "UPDATEPENDING" ?
                <Spinner />
                :
                <div class="columns" >
                    <div class="columns is-mobile" >
                        {props.type !== "MOVIE" ?
                            <div class="column is-narrow">
                                <figure class="image is-128x128">
                                    {props.editState === "READ" ?
                                        props.profileThumb() !== "UNKNOWN" && props.profile() !== "UNKNOWN" ?
                                            <Link to={"/profiles/" + props.profile().id}>
                                                <img class="is-rounded" src={props.profileThumb().source} alt={props.profileThumb().name} title={props.profileThumb().name} />
                                            </Link>
                                            :
                                            <Spinner />
                                        :
                                        ""
                                    }

                                </figure>
                            </div>
                            :
                            ""
                        }

                        {props.type !== "PROFILE" ?
                            <div class="column is-narrow" >
                                <div class="movieThumb">
                                    {props.editState === "READ" ?

                                        props.movie() !== "UNKNOWN" ?
                                            <MovieThumb movieId={props.movie().id} imageId={props.movie().thumbnail} />

                                            : <Spinner />
                                        :
                                        ""
                                    }
                                </div>
                            </div>
                            :
                            ""
                        }
                    </div>

                    <div class="column ">
                        <div >
                            {props.type !== "PROFILE" ?
                                props.editState === "READ" ?
                                    props.movie() !== "UNKNOWN" ?

                                        <span class="movieTitle">
                                            {props.movie().name}
                                        </span>
                                        :
                                        <Spinner />

                                    :
                                    <ObjectSelector url="/api/movies/" defaultValue={props.objectInputState.movie} setInputState={
                                        (id) => {
                                            const clone = { ...props.objectInputState }
                                            clone.movie = id
                                            props.setObjectInputState(clone)
                                        }}>
                                    </ObjectSelector>
                                :
                                ""
                            }
                        </div>

                        <div class="columns">
                            <div class="column is-narrow">
                                <div >
                                    {
                                        props.editState === "READ" ?
                                            props.review() !== "UNKNOWN" ?
                                                getDateString(new Date(props.review().date))
                                                :
                                                <Spinner />
                                            :
                                            <input type="date" defaultValue={props.objectInputState.date} onChange=
                                                {(event) => {
                                                    const clone = { ...props.objectInputState }
                                                    clone.date = event.target.value
                                                    props.setObjectInputState(clone)
                                                }}></input>
                                    }
                                </div>
                                <div class="rank">
                                    {
                                        props.editState === "READ" ?
                                            props.review() !== "UNKNOWN" ?
                                                props.review().score
                                                :
                                                <Spinner />
                                            :
                                            <input type="number" defaultValue={props.objectInputState.score} onChange=
                                                {(event) => {
                                                    const clone = { ...props.objectInputState }
                                                    clone.score = event.target.value
                                                    props.setObjectInputState(clone)
                                                }}></input>
                                    }
                                </div>
                            </div>
                            <div class="column">
                                <div class="block">
                                    {
                                        props.editState === "READ" ?
                                            props.review() !== "UNKNOWN" ?
                                                props.review().review
                                                :
                                                <Spinner />
                                            :
                                            <textarea class="textarea review" defaultValue={props.objectInputState.review} onChange={
                                                (event) => {
                                                    const clone = { ...props.objectInputState }
                                                    clone.review = event.target.value
                                                    props.setObjectInputState(clone)
                                                }}></textarea>}
                                </div>

                                {
                                    props.editState === "READ" ?
                                        props.review() !== "UNKNOWN" ?
                                            props.review().seenWithProfiles.length !== 0 ?
                                                <div class="columns is-mobile">
                                                    <div class="column is-narrow">
                                                        <figure class="image is-64x64">
                                                            <img src={seenWithIcon} alt="seenWith" />
                                                        </figure>
                                                    </div>

                                                    {props.review().seenWithProfiles.map((profileId) => (
                                                        <div key={profileId} class="column is-narrow">
                                                            <ThumbProfile profileId={profileId} />
                                                        </div>
                                                    ))}



                                                </div>
                                                :
                                                ""
                                            :
                                            <Spinner />
                                        :
                                        <div>
                                            <div class="columns">
                                                <div class="column">
                                                    Vu avec les utilisateurs:
                                        </div>
                                                <div class="column">
                                                    <MultiObjectSelector url="/api/profiles/" defaultValue={props.objectInputState.seenWithProfiles} setInputState={
                                                        (idList) => {
                                                            const clone = { ...props.objectInputState }
                                                            clone.seenWithProfiles = idList
                                                            props.setObjectInputState(clone)
                                                        }
                                                    }></MultiObjectSelector>
                                                </div>
                                            </div>
                                            <div class="columns">
                                                <div class="column">
                                                    Vu avec les non-utilisateurs:
                                        </div>
                                                <div class="column">
                                                    <MultiObjectSelector url="/api/outsiders/" defaultValue={props.objectInputState.seenWithOutsiders} setInputState={
                                                        (idList) => {
                                                            const clone = { ...props.objectInputState }
                                                            clone.seenWithOutsiders = idList
                                                            props.setObjectInputState(clone)
                                                        }
                                                    }></MultiObjectSelector>
                                                </div>
                                            </div>
                                        </div>

                                }
                                <ObjectModifiers
                                    modifiable={props.modifiable}
                                    editState={props.editState}
                                    updateConclusionState={props.updateConclusionState}
                                    startEdit={props.startEdit}
                                    startSave={props.startSave}
                                    startCancel={props.startCancel}
                                />
                            </div>
                        </div>

                    </div>
                </div>
            }
        </div >
    );
}

export default Review;